export default "__VITE_ASSET__10abd9d8__"